import { AutomatedTextsState } from './partials/automated-text'
import { DashboardState } from './partials/dashboard'
import { DocketEntryEditState } from './partials/docket-entry-edit'
import { PrintState } from './partials/print'
import { UploadLinksState } from './partials/upload-links'

export const DocketEntryState = _ => ({
  ...AutomatedTextsState,
  ...DashboardState,
  ...DocketEntryEditState,
  ...PrintState,
  ...UploadLinksState,

  docketEntry: {},
  docketEntryType: {},
})
